module.exports = __webpack_public_path__ + "img/right-clench.3a20e393.png";